import { render, staticRenderFns } from "./Celebrations2.vue?vue&type=template&id=4dff5d3e&scoped=true"
import script from "./Celebrations2.vue?vue&type=script&lang=js"
export * from "./Celebrations2.vue?vue&type=script&lang=js"
import style0 from "./Celebrations2.vue?vue&type=style&index=0&id=4dff5d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff5d3e",
  null
  
)

export default component.exports